import { CustomIcon } from "./Styles";
import Icon from "../../aat/components/Icon/Icon";
import React from "react";
import styled from "styled-components";
import { invert } from "polished";

export interface BasketButtonProps {
    navigateToBasket: () => void;
    basketCount: number;
    textColor: string;
}

const Count = styled.span`
    background-color: black;
    color: white;
    padding: 0rem 0.2rem;
    margin-left: 0.2rem;
    display: inline-block;
    margin-top: -0.2rem;
`;

export default function BasketButton(props: BasketButtonProps): JSX.Element {
    const { textColor, navigateToBasket, basketCount } = props;
    React.useState(0);
    return (
        <button style={{ color: textColor }} onClick={navigateToBasket} className="app-bar__btn-cart">
            <span style={{
                    color: textColor,
                }} className="app-bar__btn-cart-title">Kurv</span>
            <CustomIcon>
                <Icon name="bag" />
            </CustomIcon>
            {/* <span
                style={{
                    backgroundColor: textColor,
                    color: invert(textColor),
                }}
                className="app-bar__count basm_basket_count"
            > */}
            <Count style={{
                    backgroundColor: textColor,
                    color: invert(textColor),
                }}>{basketCount}</Count>
            {/* </span> */}
        </button>
    );
}
